import React from 'react'
import './styles/_spinner.scss'

export const Spinner = () => {
  return (
    <div className="lds-ellipsis" data-testid='spinner'><div></div><div></div><div></div><div></div></div>
  )
}
